/**
 * Remove trailing forward slashes from a string
 * @param {string} trimChar should be only 1 character
 * @param {string} target the string to be trimmed
 * @returns {string} trimmed string
 */
export function RightTrim(trimChar, target) {
  while (trimChar === target.slice(-1)) {
    target = target.slice(0, -1);
  }
  return target;
}
